import React, { useEffect, useState } from "react";
import { Controller } from "react-hook-form";
import { useSelector } from "react-redux";
import Select from "react-select";

import { selectCustomStyles } from "../../lib/constants";
import { api } from "../../utils/axios/Config";
import { cn } from "../../utils/utils";

const SelectForm = (props) => {
  const { control, label, name, className, errors, disabled } = props;
  const [options, setOptions] = useState([]);
  //   const [selectedOption, setSelectedOption] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const type = useSelector((store) => store.bussinessSlice.type);
  const businessId = useSelector((store) => store.bussinessSlice?.data?.business?.id);

  useEffect(() => {
    fetchOptions();
  }, [searchQuery]);

  const fetchOptions = async () => {
    const query = type === "real" ? "real_business_id" : "legal_business_id";
    try {
      const response = await api.get(`/forms/?${query}=${businessId}`);
      //console.log(response)
      const fetchedOptions = response.data.items.map((item) => ({
        value: item.form.name,
        label: item.form.name,
        id: item.form.id,
      }));
      setOptions(fetchedOptions);
    } catch (error) {
      console.error("Error fetching options:", error);
    }
  };

  const handleInputChange = (newValue) => {
    const query = newValue;
    setSearchQuery(query);
    return query;
  };

  return (
    <div className={cn("col-span-2 xl:col-span-1 flex flex-col gap-2", className)}>
      <label htmlFor={name} className="text-[14px] md:text-[16px]">
        {label}
      </label>
      <Controller
        control={control}
        name={name}
        render={({ field: { onChange, onBlur, value, ref } }) => (
          <Select
            styles={selectCustomStyles}
            value={options.find((option) => option.id === value?.id) || null}
            options={options}
            isDisabled={disabled}
            onInputChange={handleInputChange}
            onChange={(selectedOption) => {
              // Here, we pass the entire object to `onChange` rather than just an ID
              onChange(selectedOption ? selectedOption : null);
            }}
            placeholder="جستجو..."
            isClearable={true}
            noOptionsMessage={() => "موردی یافت نشد ..."}
          />
        )}
      />

      {errors?.message && <div className="text-red-500  text-sm">{errors?.message}</div>}
    </div>
  );
};

export default SelectForm;
